import { applySpec, filter, map, path, pathOr, pipe, split, toLower, trim } from "ramda";

export const Token = applySpec({
  access_token: path(["data", "access_token"]),
  expires_in: path(["data", "expires_in"]),
  account_id: path(["data", "account_id"]),
  country: path(["data", "country"]),
  validation_hints: pipe(pathOr('', ["headers", "validation-hints"]), split(","), filter(Boolean), map(pipe(trim, toLower))),
})